module.exports = __webpack_public_path__ + "img/H.1782a7f9.jpg";